angular.module('ihestiaRestServicesBase')

/**
 * pobieranie obrazka captcha
 */
.service('clientPersonsNbkSvc', ['IHestiaRestServiceAbstractDef', function (IHestiaRestServiceAbstractDef)
{
  var ClientPersonsNbk = function ()
  {
    IHestiaRestServiceAbstractDef.apply(this, arguments);

    this.resource = 'masterdata';
    this.businessArea = 'clients';
    this.top = 5;
    this.port = '8202';
    this.path = 'RestClients';
    this.sortDirection = 'DESC';
    this.sortBy = 'rank';

  };
  return new ClientPersonsNbk();
}]);